import React from "react";
import styles from "components/CopyLabel.module.css";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const CopyLabel = (props) => {
  const copyButtonClick = () => {
    navigator.clipboard.writeText(props.value);
  };

  return (
    <div className={styles.container}>
      <table>
        <tbody>
          <tr height="40px">
            <td align="top">
              <h5 className={styles.h5SubHeader}>{props.label}</h5>
            </td>
            <td align="top">
              <h5 className={`${styles.h5SubHeader} ${styles.bolderHeader}`}>{props.value}</h5>
            </td>
            <td align="top">
              <button className={styles.copyButton} onClick={copyButtonClick}>
                <ContentCopyIcon fontSize="small" color="action" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default CopyLabel;
